import { render } from "./PrivacyPolicyTermsAndConditions.vue?vue&type=template&id=a06054fa&ts=true"
import script from "./PrivacyPolicyTermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyTermsAndConditions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__